import React from 'react'
import { useState, useEffect , useRef } from 'react';
import Select, { components } from 'react-select';
import { AiOutlinePlusCircle, AiOutlineDelete, AiOutlineEdit } from 'react-icons/ai';
import axios from 'axios'
import ToastNotification from '../../../components/ToastNotification';
import { Modal, Button, Table, Form } from "react-bootstrap";
import { CiEdit } from "react-icons/ci";
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import { FaDownload } from "react-icons/fa6";
import logo from '../../../assets/logo.png';
import { MdDeleteForever } from "react-icons/md";
import { useLoading } from '../../../context/LoadingContext';
import jsPDF from "jspdf";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import "jspdf-autotable";
import autoTable from "jspdf-autotable";
import { useLocation } from "react-router-dom";
import { FaTimes } from 'react-icons/fa';

function RepairInvoice({ adminData, companyID, branchID,financialYear }) {
   const searchInputRef = useRef(null);

    const location = useLocation();
   
    const navData = location.state;

    const showFormFromNav = navData?.showForm;
const partyData = navData?.partyData;




    const [showForm, setShowForm] = useState(false);
    const { setLoading } = useLoading();



 useEffect(() => {
    if (showFormFromNav) setShowForm(true);

    if (partyData) {
      setFormItems((prev) => ({
        ...prev,
        party: partyData.partyid,
        partyName:partyData.party,
        // cust_enq: partyData.partyid,
        description: partyData.site,
        contact_no: partyData.contact_no,
            ref_doc: partyData.ref_doc 
      }));
    }
  }, [partyData, showFormFromNav]);

    const handleAddClick = () => {
        setShowForm(true);
    }

    const getCurrentDateTime = () => {
        const now = new Date();
        const istOffset = 5.5 * 60;
        const localOffset = now.getTimezoneOffset();
        const istTime = new Date(now.getTime() + (istOffset + localOffset) * 60000);
        const year = istTime.getFullYear();
        const month = String(istTime.getMonth() + 1).padStart(2, "0");
        const day = String(istTime.getDate()).padStart(2, "0");
        const hours = String(istTime.getHours()).padStart(2, "0");
        const minutes = String(istTime.getMinutes()).padStart(2, "0");

        return `${year}-${month}-${day}T${hours}:${minutes}`;
    };


    const [formItems, setFormItems] = useState({
        party: '',
        cust_enq: '',
        quotation_date: getCurrentDateTime(),
        sale_person: '',
        technician: '',
        grand_total: '',
        total_gst: "",
        sub_total: "",
        remark: '',
        description: '',
        ref_doc: '',
        type_acc: '',
        customLetter: '',
        subject: '',
        customLetterHTML: '',
        edit_by: '',
        edit_date: '',
        added_by: '',
        additionalDetails: [],
    })

    const [formData, setFormData] = useState([]);
    const [toast, setToast] = useState({ show: false, message: '', bg: 'success' });
    const showToast = (msg, bg = 'success') => {
        setToast({ show: true, message: msg, bg });
    };


    const [search, setSearch] = useState("");
    const [searchItem, setSearchItem] = useState("");
    const [showPartyModal, setShowPartyModal] = useState(false);
    const [showItemModal, setShowItemModal] = useState(false);
    const [items, setItems] = useState([]);
    const [selectedItemId, setSelectedItemId] = useState("");
    const [partyOptions, setPartyOptions] = useState([]);
    const [detail, setDetail] = useState([]);
    const [user, setUser] = useState([]);
    const [subTotal, setSubTotal] = useState(0);
    const [totalTax, setTotalTax] = useState(0);
    const [grandTotal, setGrandTotal] = useState(0);
    const [selectedParty, setSelectedParty] = useState("");
    const [selectedDoc, setSelectedDoc] = useState(null);
    const [isEditMode, setIsEditMode] = useState(false);
    const [quotation, setQuotation] = useState([]);
    const [editingCompanyId, setEditingCompanyId] = useState(null);
    const [selectedPrint, setSelectedPrint] = useState({});
    const [showLetterModal, setShowLetterModal] = useState(false);
    const [selectedQuotation, setSelectedQuotation] = useState(null);
    const [showDownloadModal, setShowDownloadModal] = useState(false);
    const [refDocs, setRefDocs] = useState([]);
    const [fetchPerforma, setFetchPerforma] = useState([]);
    const [searchTerm, setSearchTerm] = useState('');
    const [allRefDocs, setAllRefDocs] = useState([]);
    const [chargeMaster, setChargeMaster] = useState([]);
    const [chargeOptions, setChargeOptions] = useState([]);
    const [content, setContent] = useState("");
    const [branchDetail, setBranchDetail] = useState([])
    const [allQuotations, setAllQuotations] = useState([]);
    const [repair, setRepair] = useState([]);
    const [fetchrepairInvoice, setFetchRepairInvoice] = useState([]);
    const [callList, setCallList] = useState([]);
    const [selectedCallDoc, setSelectedCallDoc] = useState(null);

const [selectedRefDoc, setSelectedRefDoc] = useState(null);

// Call/Complaint Docs
const [callDocs, setCallDocs] = useState([]);

   const [offset, setOffset] = useState(0);
                    const limit = 20;
                    const [hasMore, setHasMore] = useState(true);
                    const [fromDate, setFromDate] = useState();
                    const [toDate, setToDate] = useState();
                    const [isLocked, setIsLocked] = useState(false);
                    const [fy, setFy] = useState([]);
                
                    const [financialRange, setFinancialRange] = useState({
                        from_date: '',
                        to_date: ''
                    });
  

                    useEffect(() => {
                      if (showPartyModal) {
                        setTimeout(() => {
                          searchInputRef.current?.focus();
                        }, 100);
                      }
                    }, [showPartyModal]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormItems(prev => ({
            ...prev,
            [name]: value
        }));


    };

    const [files, setFiles] = useState({
        file: null,

    })

    const handleFileChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            const fileSizeInMB = file.size / (1024 * 1024);
            if (fileSizeInMB > 2) {
                setToast("File size is too large! Please upload a file smaller than 2MB.", 'danger')
                return;
            }
            setFiles(prevFiles => ({ ...prevFiles, [e.target.name]: file }));
        }
    };

    const handleSelectChange = (e) => {
        const id = e.target.value;
        if (!id) return;
        const selectedItem = items.find((i) => i.id == id);
        if (!selectedItem) return;
        setFormData((prev) => [
            ...prev,
            {
                id: selectedItem.id,
                name: selectedItem.name,
                qty: "",
                rate: selectedItem.rate || 0,
                gst: "",
                amount: "",
                tax: selectedItem.tax || "",
            },
        ]);
    };

    const filtered = partyOptions.filter(
        (p) =>
            p.label.toLowerCase().includes(search.toLowerCase()) ||
            (p.phone && p.phone.toLowerCase().includes(search.toLowerCase())) ||
            (p.address && p.address.toLowerCase().includes(search.toLowerCase()))
    );

    const handleFormItemChange = (index, field, value) => {
        const updated = [...formData];
        updated[index][field] = value;
        const qty = parseFloat(updated[index].qty) || 0;
        const rate = parseFloat(updated[index].rate) || 0;
        const tax = parseFloat(updated[index].tax) || 0;
        const baseAmount = qty * rate;
        const taxAmount = parseFloat(((baseAmount * tax) / 100).toFixed(2));
        const totalAmount = parseFloat((baseAmount + taxAmount).toFixed(2));
        updated[index].baseAmount = baseAmount;
        updated[index].taxAmount = taxAmount;
        updated[index].amount = totalAmount;

        setFormData(updated);
        const subTotal = updated.reduce((sum, item) => sum + (item.baseAmount || 0), 0);
        const totalGst = updated.reduce((sum, item) => sum + (item.taxAmount || 0), 0);
        const grandTotal = updated.reduce((sum, item) => sum + (item.amount || 0), 0);

        setSubTotal(subTotal.toFixed(2));
        setTotalTax(totalGst.toFixed(2));
        setGrandTotal(grandTotal.toFixed(2));
    };



    const fetchPartyDetail = async () => {
        setLoading(true)
        try {
            const resParty = await axios.get("https://api.skyguard.group/api/fetch-party");

            const options = resParty.data.map((p) => ({
                value: p.id,
                label: p.name,
                phone: p.phone,
                address: p.address,
            }));
            const data = resParty.data;
            setDetail(data);
            setPartyOptions(options);

        } catch (error) {
            console.log(error);
        } finally {
            setLoading(false);
        }
    };

    const fectEmphDetail = async () => {
        setLoading(true)
        try {
            const resEmployee = await axios.get('https://api.skyguard.group/api/fetch-employee');
            setUser(resEmployee.data.result);

        } catch (error) {
            console.log(error)
        } finally {
            setLoading(false);
        }
    };



    const fetchChargeDetail = async () => {
        setLoading(true)
        try {
            const response = await axios.get('https://api.skyguard.group/api/fetch-master-charge');
            setChargeMaster(response.data);
            const options = response.data.map((item) => ({
                value: item.charge_name,
                label: item.charge_name
            }));

            setChargeOptions(options);

        } catch (error) {
            console.log(error)
        } finally {
            setLoading(false);
        }
    };


    const inventoryDetail = async () => {
        setLoading(true)
        try {
            const resInventory = await axios.get('https://api.skyguard.group/api/fetch-inventory');
            const items = resInventory.data.result || [];
            setItems(items);
        } catch (error) {
            console.log(error)
        } finally {
            setLoading(false);
        }
    };


       const fetchBranchDetail = async () => {
        setLoading(true)
        try {
            const branchRes = await axios.get(`https://api.skyguard.group/api/fetch-branch-localData/${branchID}`);
            setBranchDetail(branchRes.data)
            
            return branchRes.data.code;
        } catch (error) {
            console.log(error)
        } finally {
            setLoading(false);
        }
    };

       const fetchYearDetail = async () => {
                            setLoading(true);
                            try {
                                const branchCode = await fetchBranchDetail();
                             
                                const res = await axios.get(
                                    `https://api.skyguard.group/api/fetch-financial-year-localData/${financialYear}`
                                );
                                const yearData = res.data;
                                setFy(yearData);
                                setIsLocked(yearData.is_locked === 1);
                                setFinancialRange({
                                    from_date: yearData.from_date,
                                    to_date: yearData.to_date
                                });
                    
                                await repairInvoice(
                                    yearData.from_date,
                                    yearData.to_date,
                                    branchCode,
                    
                                );
                            } catch (error) {
                                console.log(error);
                            } finally {
                                setLoading(false);
                            }
                        };

    const repairQuoation = async () => {
        setLoading(true)
        try {
            const res = await axios.get('https://api.skyguard.group/api/fetch-repair-quotation');

            setRepair(res.data);
        } catch (error) {
            console.log(error)
        } finally {
            setLoading(false);
        }
    };


    const repairInvoice = async (fromDate,
        toDate,
        branchCode,
        newOffset = 0) => {
        setLoading(true)

         if (!branchCode) {
            console.log("Branch code missing");
            return;
        }


        try {
            const res = await axios.get('https://api.skyguard.group/api/fetch-repair-invoice',
                 {
                    params: {
                        from_date: fromDate,
                        to_date: toDate,
                       branchId: branchCode, 
                        limit: limit,
                        offset: newOffset
                    }
                }
            );

            const filteredData = res.data.filter(
                item => item.type_acc === 'repair_invoice'
            );

            // setFetchRepairInvoice(filteredData);

             const result = filteredData;
            if (newOffset === 0) {
              setFetchRepairInvoice(result);
                setHasMore(true);
            }

            else {
              setFetchRepairInvoice(prev => {
                    const merged = [...prev, ...result];

                    // optional: remove duplicates (safety)
                    const unique = Array.from(
                        new Map(merged.map(item => [item.id, item])).values()
                    );

                    return unique;
                });
            }

            if (result.length < limit) {
                setHasMore(false);
            }

        } catch (error) {
            console.log(error)
        } finally {
            setLoading(false);
        }
    };


    const fetchComplaints = async () => {
        try {
            const res = await axios.get("https://api.skyguard.group/api/fetch-complaint");
            setCallList(res.data);
           

        } catch (err) {
            console.error(err);
        }
    };


    useEffect(() => {
        inventoryDetail();
        fetchPartyDetail();
        fectEmphDetail();
        fetchBranchDetail();
        fetchYearDetail();
        fetchChargeDetail();
        repairQuoation();
      
        fetchComplaints();
    }, []);


    const handleUpdate = async (e) => {
        e.preventDefault();

        const sendData = new FormData();
        const safe = (v) => (v === undefined || v === null ? "" : v);

        sendData.append("type_acc", "repair_invoice");
        sendData.append("cust_enq", formItems.cust_enq);
        sendData.append("ref_doc", safe(formItems.ref_doc));

              
sendData.append("ref_doc_label", safe(formItems.ref_doc_label)); 

        sendData.append("quotation_date", formItems.quotation_date || new Date().toISOString().split("T")[0]);
        sendData.append("sale_person", formItems.sale_person);
        sendData.append("technician", formItems.technician);
        sendData.append("remark", safe(formItems.remark));
        sendData.append("description", safe(formItems.description));
        sendData.append("grand_total", grandTotal);
        sendData.append("total_gst", totalTax);
        sendData.append("sub_total", subTotal);

        sendData.append("party", safe(formItems.party));
        sendData.append("items", JSON.stringify(formData));

        sendData.append(
            "additional_charges",
            JSON.stringify(
                (formItems.additionalDetails || []).map((row) => ({
                    id: row.id || null,
                    type: row.type,
                    value1: Number(row.value1) || 0,
                    value2: Number(row.value2) || 0,
                }))
            )
        );

        sendData.append("branchId", branchDetail.code);

        if (files.file) sendData.append("file", files.file);



        const itemsSent = JSON.parse(sendData.get("items"));



        if (isEditMode && editingCompanyId) {
            sendData.append("edit_by", adminData.user.id);
        } else {
            sendData.append("added_by", adminData.user.id);
        }


        try {
            let res;

            if (isEditMode && editingCompanyId) {
                res = await axios.put(
                    `https://api.skyguard.group/api/update-repair-invoice/${editingCompanyId}`,
                    sendData,
                    { headers: { "Content-Type": "multipart/form-data" } }
                );

                showToast("Repair Quotation Updated Successfully!", "success");
            } else {
                res = await axios.post(
                    "https://api.skyguard.group/api/add-repair-invoice",
                    sendData,
                    { headers: { "Content-Type": "multipart/form-data" } }
                );
                showToast("Repair Quotation Added Successfully!", "success");
            }

            resetForm();
            repairInvoice();
        } catch (err) {
            console.error("❌ Error:", err.response?.data || err.message);
            showToast("Failed!", "danger");
        }
    };


    const resetForm = () => {
        setFormItems({
            party: "",
            cust_enq: "",
            quotation_date: getCurrentDateTime(),
            sale_person: "",
            technician: "",
            grand_total: "",
            total_gst: "",
            sub_total: "",
            remark: "",
            description: "",
            ref_doc: "",
            type_acc: "",
        });

        setFormData([]);
        setSelectedDoc(null);
        setSelectedParty(null);
        setSubTotal("0.00");
        setTotalTax("0.00");
        setGrandTotal("0.00");
        setFiles({});
        setShowForm(false);
        setRefDocs([]);
    };


    const handleEdit = async (form) => {
   
        try {

            setIsEditMode(true);
            setEditingCompanyId(form.id);
            setShowForm(true);


            let parsedItems = [];
            try {
                parsedItems = JSON.parse(form.items || "[]");
            } catch (err) {
                console.log("Invalid JSON for items:", err);
            }


            parsedItems = parsedItems.map(item => {
                const qty = parseFloat(item.qty) || 0;
                const rate = parseFloat(item.rate) || 0;
                const tax = parseFloat(item.tax) || 0;

                const baseAmount = qty * rate;
                const taxAmount = parseFloat(((baseAmount * tax) / 100).toFixed(2));
                const totalAmount = parseFloat((baseAmount + taxAmount).toFixed(2));

                return {
                    ...item,
                    baseAmount,
                    taxAmount,
                    amount: totalAmount,
                };
            });

            setFormData(parsedItems);


            let parsedAdditionalDetails = [];
            try {
                parsedAdditionalDetails = JSON.parse(form.additional_charges || "[]");
            } catch (err) {
                console.log("Invalid JSON for additional_charges:", err);
            }


            const subTotal = parsedItems.reduce((sum, item) => sum + (item.baseAmount || 0), 0);
            const totalGst = parsedItems.reduce((sum, item) => sum + (item.taxAmount || 0), 0);
            const chargesTotal = parsedAdditionalDetails.reduce((sum, item) => {
                const value = Number(item.value2) || 0;
                return item.type?.toLowerCase() === "discount" ? sum - value : sum + value;
            }, 0);
            const grandTotal = subTotal + totalGst + chargesTotal;

            setSubTotal(subTotal.toFixed(2));
            setTotalTax(totalGst.toFixed(2));
            setGrandTotal(grandTotal.toFixed(2));


            let piOptions = repair || [];
            let refDocs = piOptions.map(p => ({
                value: p.id,
                label: `RQ No. ${p.inv_no}`
            }));

            if (form.ref_doc && !refDocs.some(opt => String(opt.value) === String(form.id))) {
                refDocs.push({
                    value: form.id,
                    label: `RQ No. ${form.inv_no}`
                });
            }


            setRefDocs(refDocs);

            setFormItems(prev => ({
                ...prev,
                id: form.id || "",
                // party: form.party || "",

                //    party: partyData?.partyid || form.party || "",
party: form.party || partyData?.partyid || "",
                // partyName: form.party_name || "",
                    //  partyName: partyData.party || form.party_name || "",
                    partyName: form.party_name || partyData?.party || "",
                cust_enq: form.cust_enq || "",
                quotation_date: form.quotation_date || "",
                sale_person: form.sale_person || "",
                technician: form.technician || "",
                remark: form.remark || "",
                description: form.description || "",
                ref_doc: form.ref_doc || "", 
                // ref_doc_label:form.ref_doc_call || "",
                 ref_doc_label: form.ref_doc_label || form.ref_doc_call || (form.ref_doc ? `Call / Complaint ID: ${form.ref_doc}` : ""),       
                ref_doc_sq: form.ref_doc_sq || "", 
                ref_doc_type: form.ref_doc_type || "",
                subject: form.subject || "",
                customLetter: form.customLetter || "",
                additionalDetails: parsedAdditionalDetails,
                sub_total: Number(subTotal.toFixed(2)),
                total_gst: Number(totalGst.toFixed(2)),
                grand_total: Number(grandTotal.toFixed(2)),
                party_add: form.party_address || "",
//                     inv_no: form.inv_no || "",              
//   branchId: form.branchId || "",
branchId: form.branchId || form.branch_id || "",
inv_no: form.inv_no || form.invoice_no || "",
            }));


            setFiles({ file: form.file || null });


            setContent(form.customLetter || "");
        } catch (err) {
            console.error("❌ Error in handleEdit:", err);
        }
    };

    const handleDeleteItem = (indexToRemove) => {
        const newItems = formData.filter((_, idx) => idx !== indexToRemove);
        setFormData(newItems);

        // Then recalc totals for new array
        recalcTotals(newItems);
    };

    const handleSelectDoc = (selectedOption) => {
        if (!selectedOption) return;

        const selectedQuotation = repair.find(
            q => String(q.id) === String(selectedOption.value)
        );
        if (!selectedQuotation) return;

        // ---------- Additional Charges ----------
        const additionalDetails = selectedQuotation.additional_charges
            ? JSON.parse(selectedQuotation.additional_charges).map(c => ({
                ...c,
                value2: Number(c.value2) || 0
            }))
            : [];

        // ---------- Items ----------
        let itemsData = [];
        try {
            itemsData = JSON.parse(selectedQuotation.items).map(item => {
                const qty = Number(item.qty) || 0;
                const rate = Number(item.rate) || 0;
                const tax = Number(item.tax) || 0;

                const baseAmount = qty * rate;
                const taxAmount = +(baseAmount * tax / 100).toFixed(2);
                const amount = +(baseAmount + taxAmount).toFixed(2);

                return {
                    ...item,
                    qty,
                    rate,
                    tax,
                    baseAmount,
                    taxAmount,
                    amount
                };
            });
        } catch (err) {
            console.error("Error parsing items JSON:", err);
        }

        const subTotal = itemsData.reduce((s, i) => s + i.baseAmount, 0);
        const totalGst = itemsData.reduce((s, i) => s + i.taxAmount, 0);
        const chargesTotal = additionalDetails.reduce(
            (s, c) =>
                c.type?.toLowerCase() === "discount" ? s - c.value2 : s + c.value2,
            0
        );

        const grandTotal = subTotal + totalGst + chargesTotal;

        // ---------- SET FORM ----------
        setFormItems(prev => ({
            ...prev,
            ref_doc: selectedQuotation.id,
            party: selectedQuotation.party,
            partyName: selectedQuotation.party_name,
            cust_enq: selectedQuotation.cust_enq,
            quotation_date: selectedQuotation.quotation_date,
            sale_person: selectedQuotation.sale_person,
            technician: selectedQuotation.technician,
            description: selectedQuotation.description,
            remark: selectedQuotation.remark,
            file: selectedQuotation.file,
            additionalDetails,
            grandTotal
        }));

        setFormData(itemsData);
        setSubTotal(subTotal);
        setTotalTax(totalGst);
        setGrandTotal(grandTotal);
    };





const handleSelectCallDoc = (selectedOption) => {
  if (!selectedOption) return;

  setSelectedCallDoc(selectedOption);

  const selectedComplaint = callList.find(
    c => String(c.id) === String(selectedOption.value)
  );
  if (!selectedComplaint) return;

  // ---------- Parse items safely ----------
  let itemsData = [];
  try {
    if (selectedComplaint.items) {
      const parsedItems = typeof selectedComplaint.items === "string"
        ? JSON.parse(selectedComplaint.items)
        : selectedComplaint.items;

      if (Array.isArray(parsedItems)) {
        itemsData = parsedItems.map(item => {
          const qty = Number(item.qty ?? 0);
          const rate = Number(item.rate ?? 0);
          const tax = Number(item.tax ?? 0);
          const baseAmount = qty * rate;
          const taxAmount = +(baseAmount * tax / 100).toFixed(2);
          const amount = +(baseAmount + taxAmount).toFixed(2);

          return { ...item, qty, rate, tax, baseAmount, taxAmount, amount };
        });
      }
    }
  } catch (err) {
    console.error("Error parsing complaint items:", err);
  }

  // ---------- Calculate totals ----------
  const subTotal = itemsData.reduce((s, i) => s + i.baseAmount, 0);
  const totalTax = itemsData.reduce((s, i) => s + i.taxAmount, 0);
  const grandTotal = subTotal + totalTax; // you can add additional charges if needed

  // ---------- Set formItems ----------
  setFormItems(prev => ({
    ...prev,
    ref_doc: selectedComplaint.id,
      ref_doc_label: selectedOption.label, 
    party: selectedComplaint.partyid,
    partyName: selectedComplaint.party_name || "",
    party_add: selectedComplaint.party_address || "",
    party_phone: selectedComplaint.party_phone || "",
    party_mobile: selectedComplaint.party_mobile || "",
    complaintType: selectedComplaint.complaintType,
    created_date: selectedComplaint.date,
    description: selectedComplaint.description || "",
    customer_remark: selectedComplaint.customer_remark || "",
    status: selectedComplaint.status || "",
    branch: selectedComplaint.branch || "",
    items: itemsData
  }));

  // ---------- Set formData (important!) ----------
  setFormData(itemsData);
  setSubTotal(subTotal);
  setTotalTax(totalTax);
  setGrandTotal(grandTotal);
};


    const handleViewQuotation = (quotation) => {
        if (!quotation) {
            console.warn("No quotation passed to handleViewQuotation()");
            return;
        }

        setSelectedQuotation(quotation);
        setShowDownloadModal(true);
    };

    const updateRowField = (id, field, value) => {
        setFormItems(prev => {
            const updated = (prev.additionalDetails || []).map(row => {
                if (row.id === id) {
                    const newRow = { ...row, [field]: value };


                    if (field === "value1") {
                        const numeric = parseFloat(value) || 0;
                        newRow.value2 = ((numeric * (formData.reduce((sum, item) => sum + (item.baseAmount || 0), 0))) / 100).toFixed(2);
                    }

                    return newRow;
                }
                return row;
            });

            const newFormItems = { ...prev, additionalDetails: updated };
            recalcTotals(formData, updated);

            return newFormItems;
        });
    };



    const addRow = () => {
        setFormItems(prev => ({
            ...prev,
            additionalDetails: [
                ...(prev.additionalDetails || []),
                { id: Date.now(), type: "SGT" }
            ]
        }));
    };



    const deleteRow = (indexToRemove) => {
        const newExtra = (formItems.additionalDetails || []).filter(
            (_, idx) => idx !== indexToRemove
        );
        setFormItems((prev) => ({ ...prev, additionalDetails: newExtra }));
        recalcTotals(formData, newExtra);
    };


    const handleGstChange = (value, index) => {
        const updated = [...formData];

        updated[index].tax = value;
        const taxPercent = parseFloat(value) || 0;

        // Recalculate amounts
        const qty = parseFloat(updated[index].qty) || 0;
        const rate = parseFloat(updated[index].rate) || 0;

        const baseAmount = qty * rate;
        const gstAmount = parseFloat(((baseAmount * taxPercent) / 100).toFixed(2));
        const amount = parseFloat((baseAmount + gstAmount).toFixed(2));


        updated[index].baseAmount = baseAmount;
        updated[index].taxAmount = gstAmount;
        updated[index].amount = amount;

        setFormData(updated);


        recalcTotals(updated, formItems?.additionalDetails || []);
    };


    useEffect(() => {
        if (formData.length || (formItems?.additionalDetails?.length)) {
            recalcTotals(formData, formItems.additionalDetails || []);
        }
    }, [formData, formItems?.additionalDetails]);


    const recalcTotals = (items = [], extraRows = []) => {

        const updatedItems = Array.isArray(items) ? items : [];
        const updatedExtra = Array.isArray(extraRows) ? extraRows : [];


        const subTotal = updatedItems.reduce(
            (sum, item) => sum + (Number(item.baseAmount) || 0),
            0
        );

        const totalGst = updatedItems.reduce(
            (sum, item) => sum + (Number(item.taxAmount) || 0),
            0
        );

        // Calculate extra charges / discounts
        const chargesTotal = updatedExtra.reduce((sum, item) => {
            const value = Number(item.value2) || 0;
            return item.type?.toLowerCase() === "discount" ? sum - value : sum + value;
        }, 0);

        // Grand total
        const grandTotal = subTotal + totalGst + chargesTotal;

        // Update state
        setSubTotal(subTotal.toFixed(2));
        setTotalTax(totalGst.toFixed(2));
        setGrandTotal(grandTotal.toFixed(2));
    };


    const exportInvoiceToPDF = (selectedQuotation) => {
        const doc = new jsPDF("p", "mm", "a4");

        /* ================= HEADER ================= */
        doc.setFontSize(16);
        doc.setTextColor(0);
        doc.text("STAR SIGNATURE SERVICES", 105, 16, { align: "center" });

        doc.setFontSize(10);

        const addressText =
            "A-8 JAI ISH KRUPA CHS LTD. ANAND NAGAR OPP AL-NOOR MASZID VASAI W 401202 THANE MUMBAI MAHARASHTRA";

        const addressLines = doc.splitTextToSize(addressText, 180);
        doc.text(addressLines, 105, 22, { align: "center" });

        let currentY = 22 + addressLines.length * 5;

        doc.text(
            "BRANCH: DADAR | THANE | PUNE | AURANGABAD | GOA PANJIM",
            105,
            currentY,
            { align: "center" }
        );

        currentY += 6;

        const contactLines = doc.splitTextToSize(
            "Phone: 9209206677, 9209203355, 9324004632 | Email: starsignatureservices@gmail.com",
            180
        );
        doc.text(contactLines, 105, currentY, { align: "center" });

        currentY += contactLines.length * 5;

        doc.text("GSTIN: 27ADYPY53133M2ZH", 105, currentY + 2, {
            align: "center"
        });

        doc.setFontSize(12);
        doc.text("Repair Invoice", 105, currentY + 10, { align: "center" });

        /* ================= BILL TO / INVOICE ================= */
        autoTable(doc, {
            startY: currentY + 15,
            theme: "grid",
            styles: { fontSize: 9 },
            headStyles: {
                // fillColor: [255, 255, 255], // white header
                textColor: 0,
                fontStyle: "bold"
            },
            head: [["Bill To", "Invoice Details"]],
            body: [
                [
                    `Party Name: ${selectedQuotation.party_name}
Customer Enquiry: ${selectedQuotation.cust_enq || "-"}
Contact: ${selectedQuotation.party_phone}
Address: ${selectedQuotation.party_address}`,

                    `Invoice No: ${selectedQuotation.invoice_no || "-"}
Date: ${selectedQuotation.quotation_date}
Sale Person: ${selectedQuotation.sale_emp_first} ${selectedQuotation.sale_emp_middle || ""} ${selectedQuotation.sale_emp_last}
Technician: ${selectedQuotation.tech_emp_first || ""} ${selectedQuotation.tech_emp_middle || ""} ${selectedQuotation.tech_emp_last || ""}`
                ]
            ]
        });

        /* ================= ITEMS TABLE ================= */
        const items = selectedQuotation.items
            ? JSON.parse(selectedQuotation.items)
            : [];

        const itemRows = items.map((item, index) => [
            index + 1,
            item.name,
            item.qty,
            item.rate,
            item.tax,
            item.amount
        ]);

        autoTable(doc, {
            startY: doc.lastAutoTable.finalY + 8,
            theme: "grid",
            styles: { fontSize: 9 },
            headStyles: {
                // fillColor: [255, 255, 255], // 🔥 removes grey
                textColor: 0,
                fontStyle: "bold"
            },
            head: [["#", "Item Name", "Qty", "Rate", "GST %", "Amount"]],
            body: itemRows
        });

        /* ================= TOTALS ================= */
        autoTable(doc, {
            startY: doc.lastAutoTable.finalY + 5,
            theme: "grid",
            styles: { fontSize: 10 },
            body: [
                ["Total GST", selectedQuotation.total_gst],
                ["Sub Total", selectedQuotation.sub_total],
                ["Grand Total", selectedQuotation.grand_total]
            ],
            columnStyles: {
                0: { halign: "right", fontStyle: "bold" },
                1: { halign: "right" }
            }
        });

        /* ================= FOOTER ================= */
        let footerY = doc.lastAutoTable.finalY + 8;

        if (selectedQuotation.description) {
            doc.text(`Description: ${selectedQuotation.description}`, 14, footerY);
            footerY += 6;
        }

        if (selectedQuotation.remark) {
            doc.text(`Remark: ${selectedQuotation.remark}`, 14, footerY);
        }

        doc.save(`Invoice_${selectedQuotation.invoice_no || "NA"}.pdf`);
    };

    const formatDateTime = (datetime) => {
        if (!datetime) return "";
        const [date, time] = datetime.split(" ");
        const [year, month, day] = date.split("-");
        return `${day}-${month}-${year} ${time}`;
    };



    const filteredData = Array.isArray(fetchrepairInvoice)
        ? fetchrepairInvoice.filter(itm =>
            Object.values(itm).some(val =>
                String(val).toLowerCase().includes(searchTerm.toLowerCase())
            )
        )
        : [];

                
     const handleLoadMore = () => {

        const nextOffset = offset + limit;
        setOffset(nextOffset);

       repairInvoice (
            financialRange.from_date,
            financialRange.to_date,
            branchDetail.code,
            nextOffset
        );
    };



    return (
        <div className='main-section'>
            <ToastNotification
                show={toast.show}
                message={toast.message}
                bg={toast.bg}
                onClose={() => setToast({ ...toast, show: false })}
            />
            <div className='container-fluid dashboard-wrapper p-3 bg-body-secondary'>
                <h3 className='my-3 fw-bold fs-5 golos'>Repair Invoice</h3>
                <div class="mb-3 row gx-3 gy-2 align-items-center  d-flex justify-content-between">
                    <div class="col-12 col-md-4">
                        <input
                            type="text"
                            class="form-control"
                            id="searchInput"
                            placeholder="Search by Party Name..."
                            value={searchTerm}
                            onChange={(e) => setSearchTerm(e.target.value)}
                        />
                    </div>
                    <div className="col-12 col-md-2 d-flex justify-content-end">
                        <button className='btn btn-success' onClick={handleAddClick} >
                            <AiOutlinePlusCircle size={20} /> Add
                        </button>
                    </div>
                </div>
                {showForm && (
                    <form onSubmit={handleUpdate}>


                        <div className='card p-3 my-3 shadow-sm bg-white border'>
                            <div className='row'>

                                <div className='col-12'>
                                                                                                                 {isEditMode && (
  <div className="mb-3">
    <label>Document No:</label> <br />
    <span className="badge bg-primary px-3 py-2">
      {`RI/${formItems.inv_no}/${formItems.branchId}`}
    </span>
  </div>
)}
   
                                    <div className='row g-3'>
                                        <div className="col-12 col-md-4">
                                            <label htmlFor="party" className="form-label fw-medium">Select Party</label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                placeholder="Choose Party..."
                                                value={formItems.partyName || ""}
                                                readOnly
                                                onClick={() => setShowPartyModal(true)}
                                                required

                                            />

                                            <Modal show={showPartyModal} onHide={() => setShowPartyModal(false)} size="lg">
                                                <Modal.Header closeButton>
                                                    <Modal.Title>Search Party</Modal.Title>
                                                </Modal.Header>
                                                <Modal.Body>
                                                    <Form.Control
                                                        type="text"
                                                        placeholder="Search by name, phone, or address"
                                                        value={search}
                                                        onChange={(e) => setSearch(e.target.value)}
                                                           ref={searchInputRef}
                                                    />

                                                    <div className="table-responsive mt-3">
                                                        <Table striped bordered hover className="mt-3">
                                                            <thead>
                                                                <tr>
                                                                     <th>Action</th>
                                                                    <th>Name</th>
                                                                    <th>Phone</th>
                                                                    <th>Address</th>
                                                                   
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                {filtered.map((p) => (
                                                                    <tr key={p.value}>
                                                                          <td className="text-center" style={{ width: "80px" }}>
                                                                           

     <Button
  variant="primary"
  size="sm"
  onClick={() => {

    setFormItems(prev => ({
      ...prev,
      party: p.value,
      partyName: p.label,
      ref_doc: null,
      call_doc: null, 
      items: [],
    }));

   
    const usedRepairIds = Array.isArray(fetchrepairInvoice)
      ? fetchrepairInvoice.map(r => String(r.ref_doc))
      : [];

    const filteredRepairDocs = repair
      .filter(q => String(q.party) === String(p.value))
      .filter(q => !usedRepairIds.includes(String(q.id)))
      .map(q => ({
        value: q.id,
        label: `RQ No. ${q.inv_no}`
      }));

    setRefDocs(filteredRepairDocs);       
    setSelectedRefDoc(null);             


    const usedCallIds = Array.isArray(fetchrepairInvoice)
      ? fetchrepairInvoice.map(r => String(r.ref_doc))
      : [];

    const filteredCallDocs = callList
      .filter(c => String(c.partyid) === String(p.value))
      .filter(c => !usedCallIds.includes(String(c.id)))
      .map(c => ({
        value: c.id,
        label: `CMP/${c.id}/${c.branch}`
      }));

    setCallDocs(filteredCallDocs);         
    setSelectedCallDoc(null);              

    setShowPartyModal(false);
  }}
>
  Select
</Button>

                                                                        </td>
                                                                        <td>{p.label}</td>
                                                                        <td>{p.phone}</td>
                                                                        <td style={{ maxWidth: "300px", whiteSpace: "normal", overflow: "hidden", textOverflow: "ellipsis" }}>
                                                                            {(p.address || "").length > 50 ? `${(p.address || "").slice(0, 50)}...` : (p.address || "NA")}
                                                                        </td>
                                                                      

                                                                    </tr>
                                                                ))}
                                                            </tbody>
                                                        </Table>
                                                    </div>
                                                </Modal.Body>
                                            </Modal>
                                        </div>


                                        <div className="col-12 col-md-4">
                                            <label className="form-label fw-medium">Ref Doc</label>
                                            <Select
                                                placeholder="Choose Ref Doc..."
                                                options={refDocs}
                                                value={
                                                    refDocs.find(
                                                        opt => String(opt.value) === String(formItems.ref_doc)
                                                    ) || null
                                                }
                                                onChange={handleSelectDoc}
                                                isDisabled={isEditMode}
                                            />
                                        </div>






<div className="col-12 col-md-4">
      <label className="form-label fw-medium">Call / Complaint Doc</label>
 <Select

  placeholder="Choose Call / Complaint..."
  options={callDocs}
  value={
    selectedCallDoc || 
    (formItems.ref_doc && formItems.ref_doc_label
      ? { value: formItems.ref_doc, label: formItems.ref_doc_label }
      : null)
  }
  onChange={handleSelectCallDoc}
  isDisabled={isEditMode}
/>
</div>





                                        <div className="col-12 col-md-4">
                                            <label className="form-label fw-medium">Customer Reference No.</label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                name="cust_enq"
                                                value={formItems.cust_enq}
                                                onChange={handleChange}
                                            />
                                        </div>

                                        <div className="col-12 col-md-4">
                                            <label className="form-label fw-medium">Date</label>
                                            <input
                                                type="datetime-local"
                                                className="form-control"
                                                name="quotation_date"
                                                value={formItems.quotation_date || new Date().toISOString().split("T")[0]}
                                                onChange={handleChange}
                                            />
                                        </div>

                                        <div className="col-12 col-sm-12 col-md-4">
                                            <label className="form-label fw-medium">Sale Person</label>
                                            <Select
                                                options={user.map((t) => ({
                                                    value: t.id,
                                                    label: `${t.first} ${t.last} (${t.emp_id})`,
                                                }))}

                                                value={
                                                    user
                                                        .map((t) => ({
                                                            value: t.id,
                                                            label: `${t.first} ${t.last} (${t.emp_id})`,
                                                        }))
                                                        .find((opt) => opt.value == formItems.sale_person) || null
                                                }
                                                onChange={(e) =>
                                                    handleChange({ target: { name: "sale_person", value: e.value } })
                                                }
                                                className="w-100"
                                                menuPlacement="auto"
                                            />

                                        </div>

                                        <div className="col-12 col-sm-12 col-md-4">
                                            <label className="form-label fw-medium">Technician</label>

                                            <Select
                                                options={user.map((t) => ({
                                                    value: t.id,
                                                    label: `${t.first} ${t.last} (${t.emp_id})`,
                                                }))}

                                                value={
                                                    user
                                                        .map((t) => ({
                                                            value: t.id,
                                                            label: `${t.first} ${t.last} (${t.emp_id})`,
                                                        }))
                                                        .find((opt) => opt.value == formItems.technician) || null
                                                }
                                                onChange={(e) =>
                                                    handleChange({ target: { name: "technician", value: e.value } })
                                                }
                                                className="w-100"
                                                menuPlacement="auto"
                                            />


                                        </div>

                                        <div className="col-12 col-md-4">
                                            <label className="form-label fw-medium">Items:</label>

                                            <Select
                                                options={items.map((t) => ({
                                                    value: t.id,
                                                    label: `${t.name} (${t.stock})`,
                                                }))}

                                                value={
                                                    selectedItemId
                                                        ? {
                                                            value: selectedItemId,
                                                            label:
                                                                items.find((i) => i.id === selectedItemId)?.name +
                                                                " (" +
                                                                items.find((i) => i.id === selectedItemId)?.stock +
                                                                ")",
                                                        }
                                                        : null
                                                }

                                                onChange={(e) =>
                                                    handleSelectChange({
                                                        target: { name: "emp_id", value: e?.value || "" },
                                                    })
                                                }

                                                className="w-100"
                                                menuPlacement="auto"
                                            />
                                        </div>

                                    </div>
                                </div>

                                <div className="col-12 mt-3">
                                    <div className="table-responsive">
                                        <table className="table table-bordered text-center align-middle">
                                            <thead className="table-primary">
                                                <tr>
                                                    <th>Item Name</th>
                                                    <th>Quantity</th>
                                                    <th> Item Rate</th>
                                                    <th>Item GST</th>
                                                    <th>Amount</th>
                                                    <th>Action</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {formData.length === 0 ? (
                                                    <tr>
                                                        <td colSpan="6" className="text-center text-muted">
                                                            Select an item from the dropdown to add here
                                                        </td>
                                                    </tr>
                                                ) : (
                                                    formData.map((fi, idx) => (
                                                        <tr key={idx}>
                                                            <td><input type="text" className="form-control" value={fi.name} onChange={(e) => handleFormItemChange(idx, "name", e.target.value)} /></td>
                                                            <td><input type="number" className="form-control" value={fi.qty} onChange={(e) => handleFormItemChange(idx, "qty", e.target.value)} /></td>
                                                            <td><input type="number" className="form-control" value={fi.rate} onChange={(e) => handleFormItemChange(idx, "rate", e.target.value)} /></td>


                                                            <td>
                                                                <select
                                                                    className="form-control"
                                                                    value={fi.tax}
                                                                    onChange={(e) => handleGstChange(e.target.value, idx)}
                                                                >

                                                                    <option value={fi.tax}> {fi.tax} </option>


                                                                    <option disabled>──────────</option>


                                                                    <option value="0%">0%</option>
                                                                    <option value="5%">5%</option>
                                                                    <option value="12%">12%</option>
                                                                    <option value="18%">18%</option>
                                                                    <option value="28%">28%</option>
                                                                </select>
                                                            </td>



                                                            <td><input type="text" className="form-control" value={fi.amount || ""} readOnly /></td>
                                                            <td>
                                                                <button className="btn btn-danger" onClick={() => handleDeleteItem(idx)}>Delete</button>
                                                            </td>
                                                        </tr>
                                                    ))
                                                )}
                                            </tbody>
                                            <tfoot>


                                                <tr>
                                                    <td colSpan="3" className="text-end fw-bold">Total GST</td>
                                                    <td><input type="text"
                                                        value={totalTax}

                                                        readOnly className="form-control" /></td>
                                                    <td className="text-end fw-bold">SUB Total</td>
                                                    <td><input type="text"
                                                        value={subTotal}

                                                        readOnly className="form-control" /></td>
                                                </tr>




                                                <tr className="text-end fw-bold">
                                                    <td colSpan="6">
                                                        <div className="d-flex justify-content-end mb-2">
                                                            <button
                                                                type="button"
                                                                className="btn btn-primary btn-sm"
                                                                onClick={addRow}
                                                            >
                                                                + Add Row
                                                            </button>
                                                        </div>
                                                    </td>
                                                </tr>

                                                {formItems.additionalDetails?.map((row, index) => (
                                                    <tr key={row.id || index}>
                                                        <td colSpan="6">
                                                            <div className="d-flex justify-content-end align-items-center gap-2">
                                                                <Select
                                                                    options={chargeOptions}
                                                                    value={chargeOptions.find(option => option.value === row.type)}
                                                                    onChange={(selected) => {

                                                                        const selectedCharge = chargeMaster.find(
                                                                            (item) => item.charge_name === selected.value
                                                                        );

                                                                        // handleDetailChange(row.id, "type", selected.value);
                                                                        updateRowField(row.id, "type", selected.value);


                                                                        if (selectedCharge) {
                                                                            updateRowField(row.id, "value1", selectedCharge.charge_mrp);
                                                                        }
                                                                    }}
                                                                    placeholder="Select Charge"
                                                                    hideSelectedOptions={false}
                                                                    styles={{ container: (base) => ({ ...base, width: 150 }) }}
                                                                />


                                                                <input
                                                                    type="text"
                                                                    className="form-control"
                                                                    style={{ width: "120px" }}
                                                                    value={row.value1 || ""}

                                                                    onChange={(e) => updateRowField(row.id, "value1", e.target.value)}
                                                                />

                                                                <input
                                                                    type="text"
                                                                    className="form-control"
                                                                    style={{ width: "120px" }}
                                                                    value={row.value2 || ""}
                                                                    onChange={(e) => updateRowField(row.id, "value2", e.target.value)}
                                                                />


                                                                <button className="btn btn-danger btn-sm" onClick={() => deleteRow(index)}>

                                                                    <MdDeleteForever size={20} />
                                                                </button>
                                                            </div>
                                                        </td>
                                                    </tr>

                                                ))}


                                                <tr>
                                                    <td colSpan="5" className="text-end fw-bold">Grand Total</td>
                                                    <td><input type="text"
                                                        value={grandTotal}

                                                        readOnly className="form-control" /></td>
                                                </tr>


                                            </tfoot>
                                        </table>
                                    </div>
                                </div>


                                <div className='col-12 col-md-6 p-3'>
                                    <label className='form-label fw-medium'>Attachment</label>
                                    <input type="file" className="form-control" name='file' accept="image/*,application/pdf" onChange={handleFileChange} />

                                    {isEditMode && files.file && typeof files.file === "string" && (
                                        <div className="mt-2">
                                            <span>Previous file: </span>
                                            <a href={`https://api.skyguard.group/uploads/${files.file}`} target="_blank" rel="noopener noreferrer">{files.file}</a>
                                        </div>
                                    )}
                                </div>


                                <div className='col-12 col-md-6 p-3'>
                                    <label className='form-label fw-medium'>Description</label>
                                    <textarea className='form-control w-100' rows="5" name='description' value={formItems.description} onChange={handleChange}></textarea>
                                </div>

                                <div className='col-12 col-md-6 p-3'>
                                    <label className='form-label fw-medium'>Remark</label>
                                    <textarea className='form-control w-100' rows="5" name='remark' value={formItems.remark} onChange={handleChange}></textarea>
                                </div>

                                <div className='col-12 d-flex justify-content-center gap-2 mt-4'>
                                    <button type="submit" className='btn btn-success'>{isEditMode ? "Update" : "Save"}</button>
                                    <button type='button' className='btn btn-danger' onClick={() => { setShowForm(false); setIsEditMode(false); resetForm(); }}>Cancel</button>
                                </div>
                            </div>
                        </div>


                    </form>
                )}




                <div className='table-responsive shadow p-3 mb-5 bg-body-tertiary rounded my-4'>
                    <table className='table table-bordered table-striped table-hover text-center align-middle'>
                        <thead className='table-info'>
                            <tr>
                                {/* <th scope='col'>SN</th> */}
                                   <th scope='col' >Action</th>
                                <th scope='col' > Doc No. </th>
                                <th scope='col'>Party Name</th>
                                <th scope='col'>Addded By</th>
                                <th scope='col'>Addded Date</th>
                                <th scope='col'>Edit By</th>
                                <th scope='col'>Edit Date</th>
                             
                            </tr>
                        </thead>
                        <tbody>
                            {filteredData.map((p, i) => (
                                <tr key={p.id}>
                                    
                                    <td>

                                        <button
                                            className="btn btn-success"

                                            onClick={() => handleEdit(p)}
                                        >
                                            <CiEdit size={20} />
                                        </button>




                                        <button
                                            className="btn btn-secondary mx-1"
                                            onClick={() => {
                                                setSelectedQuotation(p);
                                                setShowDownloadModal(true);
                                            }}


                                        >
                                            <FaDownload size={20} />
                                        </button>
                                    </td>

                                    {/* <td>{`RI/${p.inv_no}/$branchDetail.code`}</td> */}
                                        <td>{`RI/${p.inv_no}/${branchDetail.code}/${fy.financial_year.split('-')[0]}`}</td>

                                    <td>{p.party_name}</td>


                                    <td>{p.added_name} {p.added_name_middle || ""} {p.added_name_last} </td>
                                    <td>{formatDateTime(p.quotation_date)}  </td>

                                    <td>{p.edit_name} {p.edit_name_middle || ""} {p.edit_name_last} </td>
                                    <td>{formatDateTime(p.edit_date)}</td>

                                </tr>
                            ))}
                        </tbody>







                        {showDownloadModal && selectedQuotation && (() => {
                            const parsedItems = selectedQuotation.items ? JSON.parse(selectedQuotation.items) : [];

                            return (
                                <div
                                    className="position-fixed top-0 start-0 w-100 h-100 d-flex justify-content-center align-items-start"
                                    style={{ backgroundColor: "rgba(0,0,0,0.5)", zIndex: 9999, overflowY: "auto", padding: "20px" }}
                                >
                                    <div
                                        className="bg-white p-4 rounded shadow"
                                        style={{
                                            width: "95%",
                                            maxWidth: "900px",
                                            position: "relative",
                                            fontFamily: "'Arial', sans-serif",
                                            color: "#333",
                                            boxSizing: "border-box"
                                        }}
                                    >
                                        {/* Close Button */}
                                        <button
                                            className="btn-close position-absolute"
                                            style={{ top: "10px", right: "10px" }}
                                            onClick={() => setShowDownloadModal(false)}
                                        ></button>

                                        {/* Header: Logo + Company Info */}
                                        <div className="position-relative text-center mb-4">
                                            {/* Logo */}
                                            <div className="mb-2">
                                                <img src={logo} alt="Company Logo" style={{ width: "120px" }} />
                                            </div>

                                            {/* Company Name */}
                                            <h2 className="fw-bold text-primary mb-1">STAR SIGNATURE SERVICES</h2>

                                            {/* Company Info */}
                                            <p className="mb-0 text-wrap  " style={{ fontSize: "14px" }}>A-8 JAI ISH KRUPA CHS LTD. ANAND NAGAR OPP AL-NOOR MASZID VASAI W 401202 THANE MUMBAI MAHARASHTRA BRANCH:#DADAR #THANE #PUNE #AURANGABAD #GOA PANJIM </p>
                                            {/* <p className="mb-0" style={{ fontSize: "14px" }}>{adminData.city}, {adminData.state}</p> */}
                                            <p className="mb-0" style={{ fontSize: "14px" }}>Phone: #9209206677 #9209203355 #9324004632 </p>
                                            <p className='mb-0' style={{ fontSize: "14px" }} >Email: starsignatureservices@gmail.com</p>

                                            <p className="mb-0" style={{ fontSize: "14px" }}>GSTIN:27ADYPY53133M2ZH </p>
                                        </div>

                                        <hr style={{ borderTop: "2px solid #ddd" }} />

                                        {/* Customer & Invoice Details Table */}
                                        <table style={{ width: "100%", marginBottom: "20px", borderCollapse: "collapse" }}>
                                            <tbody>
                                                <tr>
                                                    <td style={{ width: "50%", verticalAlign: "top", padding: "10px", border: "1px solid #ddd" }}>
                                                        <h5 className="fw-bold mb-2">Bill To:</h5>
                                                        <p className="mb-1"><strong>Party Name:</strong> {selectedQuotation.party_name}</p>
                                                        <p className="mb-1"><strong>Customer Enquiry:</strong> {selectedQuotation.cust_enq}</p>
                                                        <p className="mb-1"><strong>Contact:</strong> {selectedQuotation.party_phone}</p>
                                                        <p className="mb-1"><strong>Address:</strong> {selectedQuotation.party_address}</p>
                                                    </td>
                                                    <td style={{ width: "50%", verticalAlign: "top", padding: "10px", border: "1px solid #ddd" }}>
                                                        <h5 className="fw-bold mb-2">Invoice Details:</h5>
                                                        {/* <p className="mb-1"><strong>Invoice No:</strong> {selectedQuotation.invoice_no || "-"}</p> */}
                                                        <p className="mb-1"><strong>Date:</strong> {selectedQuotation.quotation_date}</p>
                                                        <p className="mb-1"><strong>Sale Person:</strong> {selectedQuotation.sale_emp_first} {selectedQuotation.sale_emp_middle} {selectedQuotation.sale_emp_last}</p>
                                                        <p className="mb-1"><strong>Technician:</strong> {selectedQuotation.tech_emp_first} {selectedQuotation.tech_emp_middle} {selectedQuotation.tech_emp_last}</p>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>

                                        {/* Items Table */}
                                        <table className="table table-bordered" style={{ width: "100%", borderCollapse: "collapse", marginBottom: "20px" }}>
                                            <thead style={{ backgroundColor: "#f2f2f2" }}>
                                                <tr>
                                                    <th style={{ padding: "10px", textAlign: "left" }}>Item Name</th>
                                                    <th style={{ padding: "10px" }}>Qty</th>
                                                    <th style={{ padding: "10px" }}>Rate</th>
                                                    <th style={{ padding: "10px" }}>GST %</th>
                                                    <th style={{ padding: "10px" }}>Amount</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {parsedItems.length > 0 ? parsedItems.map((fi, idx) => (
                                                    <tr key={idx} style={{ backgroundColor: idx % 2 === 0 ? "#fff" : "#f9f9f9" }}>
                                                        <td style={{ padding: "8px", textAlign: "left" }}>{fi.name}</td>
                                                        <td style={{ padding: "8px", textAlign: "center" }}>{fi.qty}</td>
                                                        <td style={{ padding: "8px", textAlign: "right" }}>{fi.rate}</td>
                                                        <td style={{ padding: "8px", textAlign: "center" }}>{fi.tax}</td>
                                                        <td style={{ padding: "8px", textAlign: "right" }}>{fi.amount}</td>
                                                    </tr>
                                                )) : (
                                                    <tr>
                                                        <td colSpan="5" className="text-center p-3">No Items Found</td>
                                                    </tr>
                                                )}
                                            </tbody>
                                            <tfoot>
                                                <tr>
                                                    <td colSpan="4" style={{ padding: "8px", textAlign: "right", fontWeight: "bold" }}>Total GST</td>
                                                    <td style={{ padding: "8px", textAlign: "right" }}>{selectedQuotation.total_gst}</td>
                                                </tr>
                                                <tr>
                                                    <td colSpan="4" style={{ padding: "8px", textAlign: "right", fontWeight: "bold" }}>Sub Total</td>
                                                    <td style={{ padding: "8px", textAlign: "right" }}>{selectedQuotation.sub_total}</td>
                                                </tr>
                                                <tr style={{ backgroundColor: "#f2f2f2" }}>
                                                    <td colSpan="4" style={{ padding: "8px", textAlign: "right", fontWeight: "bold" }}>Grand Total</td>
                                                    <td style={{ padding: "8px", textAlign: "right", fontWeight: "bold" }}>{selectedQuotation.grand_total}</td>
                                                </tr>
                                            </tfoot>
                                        </table>

                                        {/* Description & Remark */}
                                        {selectedQuotation.description && (
                                            <p><strong>Description:</strong> {selectedQuotation.description}</p>
                                        )}
                                        {selectedQuotation.remark && (
                                            <p><strong>Remark:</strong> {selectedQuotation.remark}</p>
                                        )}

                                        {/* Footer Buttons */}
                                        <div className="d-flex justify-content-end mt-4 gap-2">
                                            <button className="btn btn-primary btn-sm" onClick={() => exportInvoiceToPDF(selectedQuotation)}>
                                                Export PDF
                                            </button>
                                            <button className="btn btn-success btn-sm" onClick={() => exportInvoiceToExcel(selectedQuotation)}>
                                                Export Excel
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            );
                        })()}



                    </table>

                       {hasMore && (
                            <div className="text-center mt-3">
                                <button
                                    className="btn btn-primary"
                                    onClick={handleLoadMore}
                                >
                                    Load More
                                </button>
                            </div>
                        )}
                </div>
            </div>
        </div>
    )
}

export default RepairInvoice

export const exportInvoiceToExcel = (selectedQuotation) => {
    const items = selectedQuotation.items
        ? JSON.parse(selectedQuotation.items)
        : [];

    const data = [];

    /* ================= HEADER ================= */
    data.push({ A: "STAR SIGNATURE SERVICES" });
    data.push({
        A: "A-8 JAI ISH KRUPA CHS LTD. ANAND NAGAR OPP AL-NOOR MASZID VASAI W 401202 THANE MUMBAI MAHARASHTRA"
    });
    data.push({
        A: "BRANCH: DADAR | THANE | PUNE | AURANGABAD | GOA PANJIM"
    });
    data.push({
        A: "Phone: 9209206677, 9209203355, 9324004632 | Email: starsignatureservices@gmail.com"
    });
    data.push({ A: "GSTIN: 27ADYPY53133M2ZH" });
    data.push({});
    data.push({ A: "REPAIR INVOICE" });
    data.push({});

    /* ================= BILL TO / INVOICE DETAILS ================= */
    data.push({
        A: "Bill To",
        C: "Invoice Details"
    });

    data.push({
        A: `Party Name: ${selectedQuotation.party_name || "-"}`,
        C: `Invoice No: ${selectedQuotation.invoice_no || "-"}`
    });
    data.push({
        A: `Customer Enquiry: ${selectedQuotation.cust_enq || "-"}`,
        C: `Date: ${selectedQuotation.quotation_date || "-"}`
    });
    data.push({
        A: `Contact: ${selectedQuotation.party_phone || "-"}`,
        C: `Sale Person: ${selectedQuotation.sale_emp_first || ""} ${selectedQuotation.sale_emp_middle || ""} ${selectedQuotation.sale_emp_last || ""}`
    });
    data.push({
        A: `Address: ${selectedQuotation.party_address || "-"}`,
        C: `Technician: ${selectedQuotation.tech_emp_first || ""} ${selectedQuotation.tech_emp_middle || ""} ${selectedQuotation.tech_emp_last || ""}`
    });

    data.push({});

    /* ================= ITEMS HEADER ================= */
    data.push({
        A: "#",
        B: "Item Name",
        C: "Qty",
        D: "Rate",
        E: "GST %",
        F: "Amount"
    });

    /* ================= ITEMS ================= */
    items.forEach((item, index) => {
        data.push({
            A: index + 1,
            B: item.name,
            C: item.qty,
            D: item.rate,
            E: item.tax,
            F: item.amount
        });
    });

    data.push({});

    /* ================= TOTALS ================= */
    data.push({ E: "Total GST", F: selectedQuotation.total_gst });
    data.push({ E: "Sub Total", F: selectedQuotation.sub_total });
    data.push({ E: "Grand Total", F: selectedQuotation.grand_total });

    data.push({});

    /* ================= FOOTER ================= */
    if (selectedQuotation.description) {
        data.push({ A: `Description: ${selectedQuotation.description}` });
    }
    if (selectedQuotation.remark) {
        data.push({ A: `Remark: ${selectedQuotation.remark}` });
    }

    /* ================= EXCEL GENERATION ================= */
    const worksheet = XLSX.utils.json_to_sheet(data, {
        skipHeader: true
    });

    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Invoice");

    const excelBuffer = XLSX.write(workbook, {
        bookType: "xlsx",
        type: "array"
    });

    const blob = new Blob([excelBuffer], {
        type: "application/octet-stream"
    });

    saveAs(blob, `Invoice_${selectedQuotation.invoice_no || "NA"}.xlsx`);
};
